import leeCoreLex from 'bundles/epic/clients/leeCoreLex';

export function areDailyGoalsEnabled() {
  return leeCoreLex.preview('enableDailyGoals');
}

/**
 * Records an impression for the daily goals experiment at specific impression points.
 * Should be called only at the documented impression points:
 * - LIHP when continue learning modules are present
 * - My Learning tab
 * - In-course experience (daily task island)
 */
export function recordDailyGoalsImpression() {
  return leeCoreLex.get('enableDailyGoals');
}
